var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.25a.917.917 0 00-.917.904.753.753 0 01-.443.697 5.083 5.083 0 00-2.89 4.334v2.482a.75.75 0 01-.005.09 4.084 4.084 0 01-.583 1.66h9.676a4.084 4.084 0 01-.583-1.66.754.754 0 01-.005-.09V9.185a5.084 5.084 0 00-2.904-4.34.75.75 0 01-.43-.678A.917.917 0 0010 3.25zm-2.368.434a2.417 2.417 0 014.736 0 6.583 6.583 0 013.382 5.483v2.452a2.584 2.584 0 001.286 1.895.75.75 0 01-.37 1.403H3.334a.75.75 0 01-.37-1.403 2.583 2.583 0 001.287-1.895V9.167a6.583 6.583 0 013.382-5.483z",
    fill: "#48525C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.417a.75.75 0 01.75.75V15a1.75 1.75 0 003.5 0v-.833a.75.75 0 111.5 0V15a3.25 3.25 0 01-6.5 0v-.833a.75.75 0 01.75-.75z",
    fill: "#48525C"
  })));
};
export default SvgBell;